import {mapGetters, mapState} from "vuex";
import baseURL from "@/helpers/getBaseUrl";

import adSliderCars from "@/mixins/cars/adSliderCars";

export default {
    mixins:[adSliderCars],
    computed: {
        ...mapGetters(['showMenu']),
        ...mapState(['newBanner']),
        ...mapState({
            scrollTop: (state) => state.scrollTop,
            scrollTopCars: state => state.moduleOldCars.cars.scrollTop,
            carsByFilter: state => state.moduleOldCars.cars.items,
            carsLoaded: state => state.moduleOldCars.cars.loaded,
            frontPage: state => state.ad.frontPage,
            searchResult: state => state.ad.searchResult,
            selectedFiltersCount: state => state.selected_filters_count,
            defaultShareImage: state => state.defaultShareImage
        }),
        ...mapGetters(["isIosApp"]),
        ...mapGetters({
            getCarsIds: 'moduleOldCars/getCarsIds'
        }),
        isK7() {
            return this.$route.name === 'k7Cars'
        },
        hasCarsSlider() {
            return Object.keys(this.carsInSliders).length
        },
        carsNotFound() {
            return !this.carsByFilter.length && !this.load && !this.hasCarsSlider
        },
        notFoundImage() {
            return `${baseURL()}/img/no-results.png`
        },
        getFilter(){
            if(this.$route.name == 'k7Cars'){
                const addToFilter = {k7:true};
                return {...this.$store.state.carFilter,...addToFilter};
            }
            return this.$store.state.carFilter;
        },
        getFiltered(){
            const staticPath = ['/k7','/k7/'];
            if(staticPath.indexOf(this.$route.fullPath) >= 0){
                return true;
            }

            return Object.keys(this.$route.query).length || this.issetUserFriendlyParams;
        },
        pageTitle(){
            this.setSpecialText(null);
            if (this.issetUserFriendlyParams) {
                const filterName = this.addFilersName();
                let specialText = filterName.map(e => e.name);
                this.setSpecialText(`Notaðir ${specialText.join(" ")} bílar`);
                return  this.$store.state.specialText;
            }
            return 'Notaðir bílar';
        }
    }
}